import { accountDetails } from "@di";
import FamilyTaggingRepository from "@adapters/repositories/Reports/FamilyTagging";
export default (http) => {
    return {
        familyTagging: new FamilyTaggingRepository(http, accountDetails),
    };
};
